import apiRequest from 'shared/services/api';
import validation from 'shared/validations';
import selectors from 'shared/store/selectors';
import utils from 'shared/helpers/utils';
import { PATH } from 'shared/constant/index';
import { ACTION_TYPE } from './actionTypes';

const { STEPS } = ACTION_TYPE;

const updateCurrentStep = currentStep => ({
  type: STEPS.UPDATA_CURRENT_STEP,
  payload: { currentStep },
});

const updateStepsSuccess = steps => ({
  type: STEPS.UPDATE_STEP_SUCCESS,
  payload: { steps },
});

const updateStepsFail = error => ({
  type: STEPS.UPDATE_STEP_FAIL,
  payload: { error },
});

/**
 * Get Application Progress
 */
const getProgress = () => async (dispatch, getState) => {
  const {
    authReducer: { token },
    applicantRootReducer: {
      applicantReducer: { applicantId },
    },
    stepsReducer: { steps },
  } = getState();
  try {
    const res = await apiRequest.getApplicantProgress(applicantId, token);
    const parseUrl = (id) => {
      switch (id) {
        case 'step1':
          return null;
        case 'step2':
          return PATH.ID_PASSPORT;
        case 'step3':
          return PATH.PERSONAL_INFORMATION;
        case 'step4':
          return PATH.FATCA_CRS;
        case 'step5':
          return `${PATH.PREVIEW}/crm`;
        case 'step6':
          return PATH.PAYMENT; // PATH.PRINT_CHECKLIST;
        default:
          return null;
      }
    };
    const data = res.map(item => ({
      id: item.code,
      isActive: item.isActive,
      isCompleted: item.isCompleted,
      isContinue: item.isContinue,
      pageSource: parseUrl(item.id),
    }));

    // console.log('STEPS (NEW) ', data);
    const purgeData = res && res.length ? data : steps;

    await dispatch(updateStepsSuccess(purgeData.sort(x => x.code)));
  } catch (err) {
    await dispatch(updateStepsFail(err));
  }
};

const postProgress = steps => async (dispatch, getState) => {
  const {
    authReducer: { token },
    applicantRootReducer: {
      applicantReducer: { applicantId },
    },
    // stepsReducer: { steps },
  } = getState();

  const data = steps.map(item => ({
    code: item.id,
    id: item.id,
    userId: applicantId,
    isActive: item.isActive,
    isCompleted: item.isCompleted,
    isContinue: item.isContinue,
  }));
  // console.log('STEPS ', data);
  try {
    const res = await apiRequest.createApplicantProgress(applicantId, token, data);
    const parseUrl = (id) => {
      switch (id) {
        case 'step1':
          return null;
        case 'step2':
          return PATH.ID_PASSPORT;
        case 'step3':
          return PATH.PERSONAL_INFORMATION;
        case 'step4':
          return PATH.FATCA_CRS;
        case 'step5':
          return `${PATH.PREVIEW}/crm`;
        case 'step6':
          return PATH.PAYMENT; // PATH.PRINT_CHECKLIST;
        default:
          return null;
      }
    };
    const newData = res.map(item => ({
      id: item.code,
      isActive: item.isActive,
      isCompleted: item.isCompleted,
      isContinue: item.isContinue,
      pageSource: parseUrl(item.id),
    }));
    await dispatch(updateStepsSuccess(newData));
    // console.log('++++ ', res, data);
  } catch (err) {
    await dispatch(updateStepsFail(err));
  }
};

/**
 * Update Steps (arr of obj)
 * @param {*} intl
 */
const updateSteps = intl => (dispatch, getState) => {
  const {
    authReducer: { phoneNumber, token },
    stepsReducer: { steps },
    applicantRootReducer: {
      // applicantReducer: { emailSent },
      idPassportReducer,
      personalInformationReducer: {
        clientDetails, pep, bankDetails, sourceOfWealth, asi, clientProfileForm,
      },
      fatcaCrsReducer: {
        fatca, crs,
        // countryTax
      },
    },
    agreementReducer: {
      aofKyc, profile, ndpf, proposedPlan, aofKycProfileSignature, ndpfProposedPlanSignature,
    },
  } = getState();
  const isShowSubcription = selectors.isShowSubcription(getState());
  const clientAge = selectors.getAge(getState());
  const productMinInvestAmountData = selectors.getProductMinInvestAmountData(getState());
  const {
    idPassportPageSchema,
    clientDetailPageSchema,
    bankDetailPageSchema,
    pepPageSchema,
    sourceOfWealthPageSchema,
    asiPageSchema,
    fatcaSchema,
    crsSchema,
  } = validation;

  // const isAgreementCompleted = !!(aofKyc.selected.length === 3 && profile.selected.length === 2 && ndpf && proposedPlan && aofKycProfileSignature && ndpfProposedPlanSignature);
  const isAgreementCompleted = !!(aofKyc.selected.length === 3 && profile.selected.length === 2 && (isShowSubcription ? ndpf : (ndpf && proposedPlan)) && aofKycProfileSignature && ndpfProposedPlanSignature);

  const isStep1Completed = !!(phoneNumber && token);
  const isIdPassportCompleted = idPassportPageSchema(intl, idPassportReducer.isWithCivilId).isValidSync({ ...idPassportReducer });

  const isPersonalInfoCompleted = () => {
    const isClientDetailsCompleted = clientDetailPageSchema(intl, clientDetails.clientClassification, clientDetails.typeOfInvestment, clientDetails.product, clientDetails.investmentStrategies, clientDetails.assetAllocations, productMinInvestAmountData, clientDetails.occupation).isValidSync({ ...clientDetails });
    const isBankDetailsCompleted = bankDetailPageSchema(intl, bankDetails.bankName).isValidSync({ ...bankDetails });
    const isPepCompleted = pepPageSchema(intl, pep.isPep, clientDetails.clientClassification, clientDetails.typeOfInvestment).isValidSync({
      ...pep,
      insiderStatus: clientProfileForm.insiderStatus,
      clientClassification: clientDetails.clientClassification,
      typeOfInvestment: clientDetails.typeOfInvestment,
    });
    const isSourceOfWealthCompleted = sourceOfWealthPageSchema(intl, sourceOfWealth.sourceOfWealthFunds, sourceOfWealth.estimatedWealth, sourceOfWealth.netIncome).isValidSync({ ...sourceOfWealth });
    const isAsiCompleted = asiPageSchema(intl, asi.isPOAholder, clientAge, asi.authorityToDeal, asi.poaOccupation).isValidSync({ ...asi });

    return !!(isClientDetailsCompleted && isBankDetailsCompleted && isPepCompleted && isSourceOfWealthCompleted && isAsiCompleted);
  };
  const isFatcaCrsTaxCompleted = () => {
    const isFatcaCompleted = fatcaSchema.fatcaPageSchema(intl, fatca.fatcaQ1, fatca.fatcaQ2, fatca.fatcaQ3, fatca.fatcaQ4, fatca.fatcaQ5, fatca.fatcaQ6).isValidSync({ ...fatca });
    const isCrsCompleted = crsSchema.crsPageSchema(intl, crs.crsQ1, crs.crsQ2, crs.crsQ3, crs.crsQ4, crs.crsQ5, crs.crsQ6).isValidSync({ ...crs });
    return !!(isFatcaCompleted && isCrsCompleted);
  };
  // console.log('isAgreementCompleted ', isAgreementCompleted);
  const parseIsCompleted = (id) => {
    switch (id) {
      case 'step1':
        return isStep1Completed;
      case 'step2':
        return isIdPassportCompleted || idPassportReducer.tobeEmailed === 'tobeEmailed';
      case 'step3':
        return isPersonalInfoCompleted();
      case 'step4':
        return isFatcaCrsTaxCompleted();
      case 'step5':
        return isAgreementCompleted;
      case 'step6':
        // return !!emailSent;
        return !!(isStep1Completed && (isIdPassportCompleted || idPassportReducer.tobeEmailed === 'tobeEmailed') && isPersonalInfoCompleted() && isFatcaCrsTaxCompleted() && isAgreementCompleted);
      default:
        return false;
    }
  };
  const isSomeDataSaved = (id) => {
    // console.log('OBJ KEYS', utils.checkPropertiesIsWithValue(clientDetails));
    switch (id) {
      case 'step2':
        return !!(utils.checkPropertiesIsWithValue(idPassportReducer));
      case 'step3':
        return !!(utils.checkPropertiesIsWithValue(clientDetails) || utils.checkPropertiesIsWithValue(pep) || utils.checkPropertiesIsWithValue(bankDetails) || utils.checkPropertiesIsWithValue(sourceOfWealth) || utils.checkPropertiesIsWithValue(asi));
      case 'step4':
        return !!(utils.checkPropertiesIsWithValue(fatca) || utils.checkPropertiesIsWithValue(crs));
      case 'step5':
        return !!utils.checkPropertiesIsWithValue(getState().agreementReducer);
      default:
        return false;
    }
  };

  let newSteps = [...steps];
  newSteps = newSteps.map(item => ({
    ...item,
    isCompleted: parseIsCompleted(item.id),
    isContinue: isSomeDataSaved(item.id) && item.isActive,
    // isContinue: !item.isCompleted && currentStep === item.id,
  }));

  /** Find the index of the next incomplete */
  const findIndexOf1stIncomplete = newSteps.findIndex(x => x.isCompleted === false);
  // const getCurrentStep = newSteps.find((x, i) => i === findIndexOf1stIncomplete);

  /** mark true the isActive if index === findIndexOf1stIncomplete */
  const updatedActiveSteps = newSteps.map((item, i) => ({
    ...item,
    isActive: i === findIndexOf1stIncomplete,
  }));

  /** update isContinue value */
  const updatedSteps = updatedActiveSteps.map(item => ({
    ...item,
    isContinue: isSomeDataSaved(item.id) && item.isActive,
  }));

  // console.log(updatedSteps);
  // dispatch(updateCurrentStep(getCurrentStep.id));

  // dispatch(updateStepsSuccess(updatedSteps));

  dispatch(postProgress(updatedSteps));
};

const stepAction = {
  updateCurrentStep,
  updateSteps,

  postProgress,
  getProgress,
};

export default stepAction;
